export function getBackendAuthErrorMessage(status: number): string {
    switch (status) {
        case 401:
            return 'Unauthorized - Please contact the support team.';
        default:
            return 'Unknown Error - Please contat the support team.';
    }
}

export function getFirebaseAuthErrorMessage(code: string): string {
    switch (code) {
        case 'auth/invalid-email':
            return 'Invalid email address.';
        case 'auth/user-disabled':
            return 'This account has been disabled.';
        case 'auth/user-not-found':
            return 'No account found with this email.';
        case 'auth/wrong-password':
            return 'Incorrect password.';
        case 'auth/email-already-in-use':
            return 'This email is already in use.';
        case 'auth/weak-password':
            return 'Password is too weak.';
        case 'auth/operation-not-allowed':
            return 'Email/password sign-in is disabled.';
        case 'auth/too-many-requests':
            return 'Too many login attempts. Please try again later.';
        case 'auth/missing-password':
            return 'Please enter a password.';
        case 'auth/invalid-credential':
            return 'Invalid or expired credentials.';
        case 'auth/network-request-failed':
            return 'Network error. Please check your connection.';
        case 'auth/popup-closed-by-user':
            return 'The popup was closed before completing sign-in.';
        case 'auth/cancelled-popup-request':
            return 'Another popup is already open.';
        case 'auth/popup-blocked':
            return 'Your browser blocked the sign-in popup.';
        case 'auth/expired-action-code':
            return 'This link has expired. Please request a new one.';
        case 'auth/invalid-action-code':
            return 'Invalid or expired link.';
        case 'auth/missing-email':
            return 'Email address is required.';
        case 'auth/requires-recent-login':
            return 'Please log in again before performing this action.';
        case 'auth/multi-factor-auth-required':
            return 'Multi-factor authentication required.';
        default:
            return 'An unexpected authentication error occurred.';
    }
}